










import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: "Radio"
})
export default class Radio extends Vue {
 @Prop({required: true, default: ''}) label: string;
 @Prop({required: true}) radioValue: any;
 @Prop({required: true}) value: any;
 @Prop({default: false}) disabled: boolean;

 get isChecked(): boolean {
   return this.radioValue === this.value;
 }

 onChange(event: any) {
    this.$emit('input', event.target.value);
    this.$emit('change',  event.target.value);
 }
}
